import React from 'react';

interface ListingLayoutProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  note?: React.ReactNode;
  className?: string;
}

export const ListingLayout: React.FC<ListingLayoutProps> = ({
  children,
  footer,
  note,
  className = '',
}) => {
  return (
    <section
      className={`w-full h-full min-h-0 min-w-0 flex flex-col ${className}`}
    >
      <div className="flex flex-col flex-1 min-h-0 min-w-0 mt-2">
        <div className="flex flex-1 min-h-0 min-w-0 flex-col">{children}</div>
        {(footer || note) && (
          <div className="mt-4 -mx-(--page-padding-x,24px) -mb-[calc(var(--page-padding-bottom,16px)-8px)] space-y-4">
            {footer}
            {note && (
              <div className="px-6 pb-4">
                <div className="bg-neutral-50 dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-lg p-4 text-sm text-neutral-600 dark:text-neutral-400 shadow-sm leading-relaxed">
                  {note}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
